import { render, staticRenderFns } from "./Logs.vue?vue&type=template&id=65e91b52&scoped=true&"
import script from "./Logs.vue?vue&type=script&lang=js&"
export * from "./Logs.vue?vue&type=script&lang=js&"
import style0 from "./Logs.vue?vue&type=style&index=0&id=65e91b52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e91b52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65e91b52')) {
      api.createRecord('65e91b52', component.options)
    } else {
      api.reload('65e91b52', component.options)
    }
    module.hot.accept("./Logs.vue?vue&type=template&id=65e91b52&scoped=true&", function () {
      api.rerender('65e91b52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/service/Logs.vue"
export default component.exports